<template>
  <div class="pick-store">
    <PageHeader :title="title" />

    <div class="ui-card">
      <div class="ui-card-head">
        <span class="ui-card-icon"><AppIcon name="ic-location" /></span>
        <div class="ui-card-text">
          <h3 class="ui-card-title">Pick a store</h3>
          <p class="ui-card-help">{{ title }} works one store at a time. Choose the store to open it for.</p>
        </div>
      </div>
      <div class="pick-store-groups">
        <div v-for="g in groups" :key="g.brand" class="pick-store-group">
          <div class="pick-store-brand" v-if="groups.length > 1">{{ g.brand }}</div>
          <div class="ui-chips">
            <button v-for="s in g.stores" :key="s.shash" type="button" class="ui-chip" @click="pick(s.shash)">{{ s.s_name }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tr } from "@/i18n";
import PageHeader from "@/ui/PageHeader.vue";
import AppIcon from "@/components/icons/AppIcon.vue";
import { pageMeta } from "@/menu";

/**
 * Stands in for a page that works one store at a time (src/storeScope.js) while the top bar shows "All stores".
 * The page itself is not mounted, so nothing on it runs without a store; picking one here is the same as picking
 * it in the top bar, and the page then opens for that store.
 */
export default {
  name: "PickStore",
  components: { PageHeader, AppIcon },
  props: {
    page: { type: String, default: "" },
  },
  computed: {
    title() {
      return tr(pageMeta(this.page).title) || tr("This page");
    },
    /** The person's stores, under a heading per brand when there is more than one (the current brand first). */
    groups() {
      const stores = this.$store.state.stores;
      const list = Array.isArray(stores.stores) ? stores.stores : [];
      const groups = [];
      for (const s of list) {
        const brand = s.b_name || tr("Other");
        let group = groups.find((g) => g.brand === brand);
        if (!group) groups.push((group = { brand, bhash: s.bhash, stores: [] }));
        group.stores.push(s);
      }
      const rank = (g) => (g.bhash === stores.current.brandHash ? 0 : 1);
      return groups.sort((a, b) => rank(a) - rank(b));
    },
  },
  methods: {
    pick(shash) {
      this.$store.dispatch("setStoreDetails", shash);
    },
  },
};
</script>

<style scoped>
.pick-store {
  display: flex;
  flex-direction: column;
  gap: var(--s-5, 24px);
}
.pick-store-groups {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.pick-store-brand {
  margin-bottom: 8px;
  font-size: var(--t-caption, 12px);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
}
</style>
